import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useContractsListFiltersContext } from '../../../../../../hooks/use-get-contracts-list-filter';
import { ContractStatusEnum, ContractStatusFilterOption } from '@/features/admin/contracts/types';

const StatusFilter = () => {
  const { t } = useTranslation();
  const { status, setStatus } = useContractsListFiltersContext();

  const statusOptions: ContractStatusFilterOption[] = [
    { slug: ContractStatusEnum.CURRENT, displayValue: 'Current' },
    { slug: ContractStatusEnum.ACTIVE, displayValue: 'Active' },
    { slug: ContractStatusEnum.APPLIED, displayValue: 'Applied' },
    { slug: ContractStatusEnum.CANCELLED, displayValue: 'Cancelled' },
    { slug: ContractStatusEnum.DEPOSIT, displayValue: 'Deposit' },
    { slug: ContractStatusEnum.NOTICE, displayValue: 'Notice' },
    { slug: ContractStatusEnum.SIGNATURE, displayValue: 'Signature' },
    { slug: ContractStatusEnum.TERMINATED, displayValue: 'Terminated' },
  ];

  return (
    <div className="flex min-w-[100px] flex-col">
      <DropDown
        value={status}
        onChange={setStatus}
        placeholder="Select status"
        label="Status"
        showLabel
        className="w-full"
        displayValue={status?.displayValue}
        inputWrapperClassName="pr-[0]"
      >
        <DropDown.DropDownOptions>
          {statusOptions.map((option) => (
            <DropDown.DropDownOption key={option.slug} value={option}>
              <DropDown.DropDownOptionDefaultContent>
                {option.displayValue}
              </DropDown.DropDownOptionDefaultContent>
            </DropDown.DropDownOption>
          ))}
        </DropDown.DropDownOptions>
      </DropDown>
    </div>
  );
};

export { StatusFilter };
